var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJobBoardCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1266 12C11.2451 12 12.1519 11.1046 12.1519 10C12.1519 8.89543 11.2451 8 10.1266 8C9.00802 8 8.10126 8.89543 8.10126 10C8.10126 11.1046 9.00802 12 10.1266 12Z",
    stroke: "#6D7D8B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4276 5H3.82561C2.83134 5 2.02533 5.74619 2.02533 6.66667V13.3333C2.02533 14.2538 2.83134 15 3.82561 15H16.4276C17.4218 15 18.2279 14.2538 18.2279 13.3333V6.66667C18.2279 5.74619 17.4218 5 16.4276 5Z",
    stroke: "#6D7D8B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1899 10H15.1982",
    stroke: "#6D7D8B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06329 10H5.07163",
    stroke: "#6D7D8B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJobBoardCash);
export default __webpack_public_path__ + "static/media/NewJobBoardCash.cda23210.svg";
export { ForwardRef as ReactComponent };